import React from 'react'

const SupportVideos = ({ videoUrls }) => {
  if (!videoUrls || !Array.isArray(videoUrls) || videoUrls.length === 0) {
    return null
  }

  const baseUrl = 'https://www.payhelm.com'

  return (
    <div className="tw-mt-4 tw-mb-4">
      <h4 className="tw-text-sm tw-font-semibold tw-text-gray-800 tw-mb-3">Reference Videos</h4>
      <div className="tw-space-y-3">
        {videoUrls.map((videoPath, index) => {
          const fullVideoUrl = `${baseUrl}${videoPath}`
          return (
            <div key={index} className="tw-w-full tw-max-w-2xl">
              <video
                controls
                className="tw-w-full tw-rounded-lg tw-shadow-sm tw-border tw-border-gray-200"
                style={{ maxHeight: '400px' }}
              >
                <source src={fullVideoUrl} type="video/mp4" />
                <source src={fullVideoUrl} type="video/webm" />
                <source src={fullVideoUrl} type="video/ogg" />
                Your browser does not support the video tag.
              </video>
              <div className="tw-text-xs tw-text-gray-500 tw-mt-1">
                Video {index + 1} of {videoUrls.length}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default SupportVideos